export enum environments {
  prod = 'PROD',
  dev = 'DEV',
  local = 'LOCAL',
}
